import { Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import NoChannelImage from "@/assets/images/no_channel.svg";
import { NoChannelsProps } from "../../types";

const NoChannels = ({ toggleAddNotificationChannel }: NoChannelsProps) => {
  return (
    <Stack
      direction="column"
      align="center"
      justify="center"
      className="al-w-full al-h-[483px] al-rounded-md al-bg-white"
    >
      <img src={NoChannelImage} alt="Empty notification channels illustration" />
      <div className="al-text-2xl al-font-medium al-text-blue-900 al-text-center al-mb-1">
        No notification channel found
      </div>
      <div className="al-text-sm al-text-gray-500 al-text-center al-mb-5">
        Add channel for notification
      </div>
      <Button onClick={toggleAddNotificationChannel}>Add notification channel</Button>
    </Stack>
  );
};

export default NoChannels;